import { Product } from '@dfds-frontend/tracking'

import { getSession } from '@/utils'
import getCookieConsent from '@/utils/getCookieConsent'
import getGaClientId from '@/utils/getGaClientId'
import { getUserSegmentId } from '@/utils/getUserSegmentId'

import { TrackingData } from '../_actions/getTrackingData'
import { trackPurchaseSegment } from '../_actions/trackPurchaseSegment'

export const trackOrderCompletedSegment = (data: TrackingData, products: Product[], basketId: string): void => {
  const anonymousUserId = getUserSegmentId()
  if (!anonymousUserId) return

  const vehicleCode = data.vehicleCode ? `${data.vehicleCode}|${data.trailerCode}` : data.vehicleCode

  void trackPurchaseSegment({
    adults: data.numberAdults,
    anonymousUserId,
    cartId: basketId,
    childrens: data.agesOfChildren,
    cookie: getCookieConsent(),
    currency: data.currency,
    gaClientId: getGaClientId(),
    orderId: data.reservationCode!,
    path: window.location.pathname,
    products,
    referrer: document.referrer,
    search: window.location.search,
    sessionId: getSession()?.sessionId,
    title: document.title,
    url: document.URL,
    vehicle: vehicleCode ?? '',
  })
}
